'use strict';

var Sugar = require('sugar-core');

Sugar.Number.defineInstance({

  'toNumber': function(n) {
    return n.valueOf();
  }

});

module.exports = Sugar.Number.toNumber;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/toNumber.js
// module id = 744
// module chunks = 0